import {Address} from './Address';

export class EmvBulkAddress extends Address {
  bulkContactName?: string;
  bulkCompany?: string;
}
